import React, { useRef } from "react";
import { useLocation } from "react-router-dom";

import { useIsMobile } from "@/hooks/useMediaQuery";

/**
 * Soft cross-fade between screens on phones.
 *
 * Deliberately opacity-only: a transform on this wrapper would turn it into the
 * containing block of every `position: fixed` descendant (FABs, bars…) for the
 * duration of the animation and make them jump.
 */
export default function PageTransition({ children }) {
  const { pathname } = useLocation();
  const isMobile = useIsMobile();
  const first = useRef(true);
  const animate = isMobile && !first.current;
  // After the very first render every route change animates.
  React.useEffect(() => {
    first.current = false;
  }, []);

  return (
    <div
      key={pathname}
      className={animate ? "animate-in fade-in-0 duration-200" : undefined}
    >
      {children}
    </div>
  );
}
